import { ticker } from "pixi.js";

export type Curve_t = (duration: number, estimate: number, init: number, end: number) => number;



/**
 * simple-dimple targeted animator
 */
export class SinkaTweener {
    private v: Object;
    private init: Object;
    private end: Object;
    private timer: ticker.Ticker | undefined;
    public isStoped: boolean = false;
    public duration: number = 0;
    public estimate: number = 0;
    public isLooped: boolean = false;
    constructor(public readonly target: Object) {

    }

    stop() {
        this.isStoped = true;
    }

    pause() {
        if (this.timer)
            this.timer.stop();
    }

    resume() {
        if (this.timer)
            this.timer.start();
    }

    destroy() {
        if (this.timer) {
            this.timer.stop();
            this.isStoped = true;
        }
    }

    animateTo(keys: Object, duration: number, callback: (animator: SinkaTweener) => void | null, curve: Curve_t | null = null) {
        if (!duration) return Promise.resolve();
        this.duration = duration;
        this.estimate = duration;
        this.isStoped = false;
        if (!this.timer) {
            this.timer = new ticker.Ticker();
            return new Promise((resolve) => {
                this.v = {};
                this.init = {};
                this.end = {};
                Object.keys(keys).forEach(key => {
                    this.v[key] = (keys[key] - this.target[key]) / duration;
                    this.init[key] = this.target[key];
                    this.end[key] = keys[key];
                });
                let animationCb = () => {
                    if (this.isStoped) { this.timer.remove(animationCb, this); this.timer.stop(); return; }
                    this.estimate -= this.timer.elapsedMS / 1000;

                    Object.keys(keys).forEach(key => {
                        if (!curve)
                            this.target[key] = keys[key] - this.v[key] * this.estimate;
                        else {
                            //TODO: replace to integral form
                            this.target[key] = curve(this.duration, this.estimate, this.init[key], this.end[key]);

                        }
                    });
                    if (this.estimate <= 0.0) {
                        this.timer.remove(animationCb, this);
                        Object.keys(keys).forEach(key => {
                            this.target[key] += this.v[key] * this.estimate;

                        });
                        if (callback) {
                            callback(this);
                        }
                        if (this.isLooped) {
                            if (this.target === undefined) {
                                this.destroy();
                                return;
                            }
                            Object.keys(this.init).forEach(key => {
                                this.target[key] = this.init[key];
                            })
                            this.animateTo(this.end, duration, callback, curve);
                        }
                        else
                            this.destroy();
                    }
                    return;
                }
                this.timer.add(animationCb, this);
                this.timer.start();
            });
        }
        else {
            this.v = {};
            this.init = {};
            this.end = {};
            Object.keys(keys).forEach(key => {
                this.v[key] = (keys[key] - this.target[key]) / duration;
                this.init[key] = this.target[key];
                this.end[key] = keys[key];
            });
            this.timer.start();
        }
    }

}
